import {useRouter} from "next/router";
import {useEffect, useState} from "react";

import {enGB} from "date-fns/locale/en-GB";
import {pl} from "date-fns/locale/pl";
import {ru} from "date-fns/locale/ru";
import {uk} from "date-fns/locale/uk";

export const getFnsLocale = (locale?: string) => {
	switch (locale || '')
	{
		case 'en':
			return enGB;
		case 'ru':
			return ru;
		case 'uk':
			return uk;
		case 'pl':
			return pl;
	}

	return uk;
}

export default function useFNSLocale() {
	const router = useRouter();

	const [locale, setLocale] = useState(getFnsLocale(router.locale));

	useEffect(() => {
		setLocale(getFnsLocale(router.locale));
	}, [router.locale]);

	return locale;
}